import $ from 'jquery';
import './../lib/jquery/jquery.textchange.js';
import Texter from "./texter.es6";
import {textareaAutoresizeOne} from "./textareaAutoresize";
import ProgressButton from "./progressButton";
import NewCollectionAction from './actions/NewCollectionAction.es6';
import {isEnterEvent, noop, scrollIntoView} from "./playUtil.es6";
import Modaller from "./modaller";
import FileUpload from "./fileUpload.es6";
import {escapeHtml} from "./escapeHtml.es6";
import {configureSideTextEditor} from "./memo/EditCardEditor";

require('jsrender')($);

// const log = console.log;
const log = $.noop;

function _joinLowerCaseStartingLinesOfText(plainText) {
    const lines = [];

    let line = '';
    for (let i = 0; i < plainText.length; ++i) {
        const ch = plainText[i];
        if (ch === '\r') {
            continue;
        }

        if (ch === '\n') {
            lines.push(line);
            line = '';
        } else {
            line += ch;
        }
    }
    if (line.length > 0) {
        lines.push(line);
    }

    _joinLowerCaseStartingLinesOfArray(lines);

    return lines.join('\n');
}

function _joinLowerCaseStartingLinesOfArray(lines) {
    const lowerCaseStartTester = _lowerCaseStartTester();

    for (let ri = lines.length - 1; ri > 0; --ri) {
        const line = lines[ri];
        if (lines[ri - 1].length > 0 && lowerCaseStartTester(line)) {
            lines[ri - 1] += ' ' + line;
            lines.splice(ri, 1);
        }
    }
    return lines;
}

function _lowerCaseStartTester() {
    const firstSymbolGetter = /^\s*(.)/;
    return function (s) {
        if (s === null || s.length === 0) {
            return false;
        }

        const match = firstSymbolGetter.exec(s);
        if (match) {
            const firstChar = match[1];
            return firstChar !== firstChar.toUpperCase();
        }
        return false;
    };
}

function _dashRegex() {
    const e = _escapeRegexPattern;
    /// /[‐‑‒–—―]+/
    return new RegExp('[' + ['‐', '‑', '-', '‒', '–', '—', '―', '−'].map(e).join('') + ']+');
}

function _escapeRegex(s) {
    if (s !== null && s.length > 0) {
        return new RegExp(_escapeRegexPattern(s));
    }
    return null;
}

function _escapeRegexPattern(s) {
    if (s !== null && s.length > 0) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    return s;
}

const LIST_ITEM_TMPL = $.templates(`
<div class="fl-form-cards__li" data-card="{{:index}}">
    <div class="fl-form-cards__card panel">
        <div class="fl-form-cards__index"></div>
        <div class="fl-form-cards__faces row">
            {{if card}}<input type="hidden" name="cards[{{:index}}].card" value="{{:card}}">{{/if}}
            {{if version}}<input type="hidden" name="cards[{{:index}}].version" value="{{:version}}">{{/if}}
            <div class="col-md-6 fl-form-cards__face-side">
                    <div class="fl-form-cards__side-input">
                        <input type="hidden" name="cards[{{:index}}].faceH"  value="{{:faceH}}">
                        <textarea class="form-control fl-form-cards__face-text {{if faceError}}is-invalid{{/if}}" style="display: none;" name="cards[{{:index}}].face" placeholder="{{>~l18n.get('packEditor.card.term.placeholder')}}" data-autoresize rows="1">{{>face}}</textarea>
                        {{if faceError}}<div class="invalid-feedback">{{>faceError}}</div>{{/if}}
                        
                        {{if faceAudio}}<div class="fl-form-cards__side-audio">
                                    <input type="hidden" name="cards[{{:index}}].faceAudio" value="{{attr:faceAudio}}">
                                    <button type="button" class="btn" data-handler="playAudio"><span class="far fa-play-circle"></span></button>
                                    <audio src="{{attr:faceAudioSrc}}"></audio>
                                </div>{{/if}}
                    </div>
                    {{if faceImage}}<div class="fl-form-cards__side-picture">
                            <input type="hidden" name="cards[{{:index}}].faceImage" value="{{attr:faceImage}}">
                            <img src="{{attr:faceImageSrc}}" alt="">
                        </div>{{/if}}
                    <div class="fl-form-cards__face-buttons">
                        <button type="button" class="btn btn-sm" data-handler="selectFaceImage"><span class="fc fc-image"></span></button>
                        <button type="button" class="btn btn-sm" data-handler="selectFaceAudio"><span class="far fa-microphone"></span></button>
                    </div>
            </div>
            <div class="col-md-6 fl-form-cards__back-side fl-form-cards__back-side--sm-bl">
                    <div class="fl-form-cards__side-input">
                        <input type="hidden" name="cards[{{:index}}].backH"  value="{{:backH}}">
                        <textarea class="form-control fl-form-cards__back-text {{if backError}}is-invalid{{/if}}" style="display: none;" name="cards[{{:index}}].back" placeholder="{{>~l18n.get('packEditor.card.def.placeholder')}}" data-autoresize rows="1">{{>back}}</textarea>
                        {{if backError}}<div class="invalid-feedback">{{>backError}}</div>{{/if}}
                        
                        {{if backAudio}}
                                <div class="fl-form-cards__side-audio">
                                    <input type="hidden" name="cards[{{:index}}].backAudio" value="{{attr:backAudio}}">
                                    <button type="button" class="btn" data-handler="playAudio"><span class="far fa-play-circle"></span></button>
                                    <audio src="{{attr:backAudioSrc}}"></audio>
                                </div>
                        {{/if}}
                    </div>
                    {{if backImage}}
                        <div class="fl-form-cards__side-picture">
                            <input type="hidden" name="cards[{{:index}}].backImage" value="{{attr:backImage}}">
                            <img src="{{attr:backImageSrc}}" alt="">
                        </div>
                    {{/if}}
                    <div class="fl-form-cards__back-buttons">
                        <button type="button" class="btn btn-sm" data-handler="selectBackImage"><span class="fc fc-image"></span></button>
                        <button type="button" class="btn btn-sm" data-handler="selectBackAudio"><span class="far fa-microphone"></span></button>
                    </div>
            </div>
        </div>
    </div>
    <div class="fl-form-cards__delete">
        <button type="button" class="btn btn-lg btn-default text-muted" data-handler="remove" title="Remove this card"><span class="far fa-times-circle"></span></button>
    </div>
</div>
`);

function textareaLength(jqTextarea) {
    const val = jqTextarea.val();
    return typeof val === 'string' ? val.length : 0;
}

class ListEditor {
    constructor(l18n) {
        this.l18n = l18n;
        this.list = $('#cardList');
        this.seed = 0;
        this.bubbleMenuPlace = null;

        const self = this;
        this.list
            .on('hastext', 'textarea', () => this.countCards())
            .on('notext', 'textarea', () => this.countCards())
            .on('click', 'button[data-handler=remove]', function () {
                const li = $(this).closest('div.fl-form-cards__li');
                li.slideUp(li.remove.bind(li));
            })
            .on('click', 'button[data-handler=selectFaceImage]', function () {
                const li = $(this).closest('div.fl-form-cards__li');
                self.selectFaceImage(li.data('card'));
            })
            .on('click', 'button[data-handler=selectFaceAudio]', function () {
                const li = $(this).closest('div.fl-form-cards__li');
                self.selectFaceAudio(li.data('card'));
            })
            .on('click', 'button[data-handler=selectBackImage]', function () {
                const li = $(this).closest('div.fl-form-cards__li');
                self.selectBackImage(li.data('card'));
            })
            .on('click', 'button[data-handler=selectBackAudio]', function () {
                const li = $(this).closest('div.fl-form-cards__li');
                self.selectBackAudio(li.data('card'));
            })
            .on('click', 'button[data-handler=playAudio]', function () {
                const button = $(this);
                const audio = button.parent().find('audio').get(0);
                if (!button.data('subscribed')) {
                    const toggle = function () {
                        button.find('span')
                            .toggleClass('fa-play-circle fa-pause-circle text-success');
                    };

                    audio.addEventListener('pause', () => {
                        log('paused');
                        toggle();
                    });
                    audio.addEventListener('play', () => {
                        log('play');
                        toggle();
                    });
                    button.data('subscribed', true);
                }
                if (audio.paused) {
                    audio.play();
                } else {
                    audio.pause();
                }
            })
            .on('input', 'textarea', function (e) {
                textareaAutoresizeOne(e.currentTarget);
            })
            .on('focus', 'textarea', function (e) {
                textareaAutoresizeOne(e.currentTarget);
            });


        this.onCardChange = $.noop;

        this.selectAudioModal_recordingOff = `
                    <span class="far fa-microphone"></span><br>
                    <div>${this.l18n.get('packEditor.audio.record')}</div>
        `;
        this.selectAudioModal_recordingOn = `
                    <span class="far fa-microphone-alt-slash"></span><br>
                    <div data-bind="timeout"></div>
        `;
        this.selectAudioModalBody = $.templates(`
<div class="position-relative">
    <button class="btn position-absolute" style="top: -1rem;right: -1rem;padding: .5em;" data-click="closeDialog"><span class="far fa-times-circle"></span></button>
    <div class="mr-4">
        <input type="file" class="d-none" accept="audio/*">

        <div class="row text-center">
        {{if canRecord}}
            <div class="col">
                <button type="button" class="btn btn-lg btn-outline-secondary" data-click="recordAudio">
                    ${this.selectAudioModal_recordingOff}
                </button>
            </div>
        {{/if}}
            <div class="col">
                <button type="button" class="btn btn-lg btn-outline-secondary" data-click="chooseAudio">
                    <span class="far fa-upload"></span><br>
                    <div>${this.l18n.get('packEditor.audio.upload')}</div>                
                </button>
            </div>
        {{if canDelete}}
            <div class="col">
                <button type="button" class="btn btn-lg btn-outline-danger" data-click="removeAudio" title="${this.l18n.get('packEditor.audio.remove')}">
                    <span class="far fa-trash-alt"></span><br>
                    <div>${this.l18n.get('packEditor.audio.remove')}</div>
                </button>
            </div>
        {{/if}}
        </div>
    </div>
</div>
`);

        this.cardListItemAudio = $.templates(`
<div class="fl-form-cards__side-audio">
    <button type="button" class="btn" data-handler="playAudio"><span class="far fa-play-circle"></span></button>
    <audio></audio>
</div>
`);
    }

    countCards() {
        let cardCount = 0;

        this.listItems.each(function () {
            if (ListEditor._isListItemHasData(this)) {
                cardCount += 1;
            }
        });

        this.onCardChange(cardCount);
        return cardCount;
    }

    get listItems() {
        return this.list.find('div[data-card]');
    }

    static _isListItemHasDataInSide(sideDiv) {
        return textareaLength(sideDiv.find('textarea.fl-form-cards__face-text')) > 0
            || sideDiv.find('.fl-form-cards__side-picture').length > 0
            || sideDiv.find('.fl-form-cards__side-audio').length > 0;
    }

    static _isListItemHasData(div) {
        div = $(div);
        if (ListEditor._isListItemHasDataInSide(div.find('.fl-form-cards__face-side')) || ListEditor._isListItemHasDataInSide(div.find('.fl-form-cards__back-side'))) {
            return true;
        }
    }

    appendEmpty() {
        this.appendRow({});
    }

    appendRow(data) {
        data.index = this.seed++;

        const html = $(LIST_ITEM_TMPL.render(data, this));

        this.list.append(html);
        this.configureCardEditor(data.index);
    }

    configureCardEditor(id) {
        configureSideTextEditor(document.querySelector(`textarea[name="cards[${id}].face"]`))
        configureSideTextEditor(document.querySelector(`textarea[name="cards[${id}].back"]`))
    }

    appendRowList(rowList) {
        const postOp = [];

        const html = rowList
            .map(row => {
                row.index = this.seed++;
                postOp.push(() => this.configureCardEditor(row.index))
                return LIST_ITEM_TMPL.render(row, this);
            })
            .join("");
        this.list.append(html);

        postOp.forEach(f => f());
    }

    removeEmptyTail() {
        const items = this.listItems;
        for (let i = items.length - 1; i >= 0; --i) {
            if (ListEditor._isListItemHasData(items.get(i))) {
                return;
            }
            $(items.get(i)).remove();
        }
    }

    clear() {
        this.list.empty();
        this.seed = 0;
    }

    /**
     *
     * @param {int} cardIndex
     * @param {jQuery} cardSide
     * @param {String} cardSideName 'back' or 'face'
     */
    _selectImageDialog(cardIndex, cardSide, cardSideName) {
        const inputPrefix = `cards[${cardIndex}].${cardSideName}`;
        const imageExists = cardSide.find('.fl-form-cards__side-picture').length > 0;

        new SelectImageDialog({
            l18n: this.l18n,
            canDelete: !!imageExists,
            remove: () => {
                cardSide.find('.fl-form-cards__side-picture').remove();
            },
            complete: (imageSrc, imageInput, imageString) => {
                // result.fileInput
                cardSide
                    .find('.fl-form-cards__side-picture').remove().end()
                    .find('.fl-form-cards__side-input').after(SelectImageDialog_ListItemImage.render({inputPrefix: inputPrefix, src: imageSrc}));

                if (imageInput) {
                    imageInput = $(imageInput);
                    imageInput.attr('name', `${inputPrefix}ImageF`);
                    cardSide.find('.fl-form-cards__side-picture').append(imageInput.remove());

                    imageString = 'local';
                }

                if (imageString) {
                    cardSide.find('.fl-form-cards__side-picture').append($(`<input type="hidden" name="${inputPrefix}Image" value="${imageString}">`));
                }
            }
        });
    }

    /**
     *
     * @param {int} cardIndex
     * @param {jQuery} cardSide
     * @param {String} cardSideName 'back' or 'face'
     */
    _selectAudioDialog(cardIndex, cardSide, cardSideName) {
        const inputPrefix = `cards[${cardIndex}].${cardSideName}`;

        const cardListItemAudio = this.cardListItemAudio;

        const audioExists = cardSide.find('.fl-form-cards__side-audio').length > 0;

        function completer(modaller, audioFileInput, audioBlob) {
            // result.fileInput
            cardSide
                .find('.fl-form-cards__side-audio').remove().end()
                .find('.fl-form-cards__side-input').append(cardListItemAudio.render());

            const audioContainer = cardSide.find('.fl-form-cards__side-audio');

            if (audioFileInput) {
                audioContainer.find('audio').get(0).src = URL.createObjectURL(audioFileInput.files[0]);

                audioFileInput = $(audioFileInput);
                audioFileInput.attr('name', `${inputPrefix}AudioF`);
                audioContainer.append(audioFileInput.remove());
            }

            if (audioBlob) {
                const reader = new FileReader();
                reader.onloadend = function (event) {
                    audioContainer.find('audio').get(0).src = URL.createObjectURL(audioBlob);

                    const input = document.createElement('input');
                    input.name = `${inputPrefix}AudioB`;
                    input.type = 'hidden';
                    input.value = event.target.result;
                    audioContainer.append(input);
                };
                reader.readAsDataURL(audioBlob);
            }

            modaller.close();
        }

        const dialogOptions = {
            canDelete: audioExists,
            canRecord: 'mediaDevices' in navigator && navigator.mediaDevices != null
        };

        Modaller.showLocal(this.selectAudioModalBody.render(dialogOptions), modaller => {
            const content = modaller.content;
            const buttonRecordingOn = this.selectAudioModal_recordingOn;
            const buttonRecordingOff = this.selectAudioModal_recordingOff;

            class RecordController {
                constructor(stream) {
                    this.chunks = [];
                    this._save = false;

                    this._timerEnd = null;
                    this._timer = null;

                    this.media = new MediaRecorder(stream);
                    this.media.addEventListener("dataavailable", event => {
                        this.chunks.push(event.data);
                    });
                    this.media.addEventListener("stop", event => {
                        log('record stop');

                        content.find('button[data-click=recordAudio]')
                            .removeClass('btn-primary')
                            .addClass('btn-outline-secondary')
                            .empty().append(buttonRecordingOff);

                        if (this._timer != null) {
                            clearInterval(this._timer);
                            this._timer = null;
                        }

                        if (this._save) {
                            modaller.close();
                        }

                        event.target.stream
                            .getTracks()
                            .forEach(track => track.stop());

                        const blob = new Blob(this.chunks, {
                            type: event.target.mimeType
                        });
                        completer(modaller, null, blob);
                    });
                    this.media.addEventListener("start", () => {
                        log('record start');

                        content.find('button[data-click=recordAudio]')
                            .addClass('btn-primary')
                            .removeClass('btn-outline-secondary')
                            .empty().append(buttonRecordingOn);

                        const timerPlace = content.find('div[data-bind=timeout]');
                        const timerPlaceUpdate = () => {
                            const left = Math.ceil((this._timerEnd - Date.now()) / 1000);
                            timerPlace.text(left + ' sec');
                        };

                        this._timer = setInterval(timerPlaceUpdate, 200);
                        timerPlaceUpdate();
                    });
                }

                start(timeout) {
                    this._timerEnd = Date.now() + timeout;

                    this.media.start();
                    setTimeout(this.complete.bind(this), timeout);
                }

                _stop() {
                    if (this.media != null) {
                        this.media.stop();
                        this.media = null;
                    }
                }

                complete() {
                    if (this.media == null) {
                        return;
                    }
                    log('complete record');
                    this._save = true;
                    this._stop();
                }

                cancel() {
                    if (this.media == null) {
                        return;
                    }
                    log('cancel record');
                    this._stop();
                }
            }

            let recorder = null;

            modaller.center();

            content.find('button[data-click=closeDialog]').click(() => {
                if (recorder != null) {
                    recorder.cancel();
                }
                modaller.close();
            });

            // remove previous file
            content.find('button[data-click=removeAudio]').click(() => {
                cardSide.find('.fl-form-cards__side-audio').remove();
                if (recorder != null) {
                    recorder.cancel();
                }
                modaller.close();
            });

            // record file
            content.find('button[data-click=recordAudio]').click(() => {
                if (recorder === null) {
                    navigator.mediaDevices.getUserMedia({audio: true}).then(
                        stream => {
                            log('recording start');

                            recorder = new RecordController(stream);
                            recorder.start(15000);
                        },
                        error => {
                            log('recording failed', error);

                            if (error.name === 'NotAllowedError') {
                                alert('Recording not allowed. Please, allow access to the microphone for this site.')
                            }
                            if (error.name === 'NotFoundError') {
                            }

                            recorder = null;
                        });
                } else {
                    recorder.complete();
                    recorder = null;
                }
            });

            // load local file
            const fileInput = content.find('input[type=file]');
            fileInput.change(function () {
                if (this.files && this.files[0]) {
                    completer(modaller, this, null);
                }
            });
            content.find('button[data-click=chooseAudio]').click(() => {
                if (recorder != null) {
                    recorder.cancel();
                }
                fileInput.click();
            });
        });
    }

    selectFaceImage(card) {
        const cardSide = this.list.find(`.fl-form-cards__li[data-card=${card}] .fl-form-cards__face-side`);
        this._selectImageDialog(card, cardSide, 'face');
    }

    selectBackImage(card) {
        const cardSide = this.list.find(`.fl-form-cards__li[data-card=${card}] .fl-form-cards__back-side`);
        this._selectImageDialog(card, cardSide, 'back');
    }

    selectFaceAudio(card) {
        const cardSide = this.list.find(`.fl-form-cards__li[data-card=${card}] .fl-form-cards__face-side`);
        this._selectAudioDialog(card, cardSide, 'face');
    }

    selectBackAudio(card) {
        const cardSide = this.list.find(`.fl-form-cards__li[data-card=${card}] .fl-form-cards__back-side`);
        this._selectAudioDialog(card, cardSide, 'back');
    }
}

const SelectImageDialog_ModalBody = $.templates(`
<div class="position-relative">
    <button class="btn position-absolute ml-3" style="top: -1rem;right: -1rem;padding: .5em;" data-click="closeDialog"><span class="far fa-times-circle"></span></button>
    <div class="form-inline">
        
        <input type="file" class="d-none" accept="image/jpeg,image/png">

        <span class="mb-3">{{>~l18n.get('packEditor.images.search')}}</span>
        <div class="input-group mb-3 mx-3">
            <input type="text" class="form-control">
            <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" data-click="searchImage" disabled><span class="far fa-search"></span></button>
            </div>
        </div>
        <div class="mb-3">
            <span class="mr-3">{{>~l18n.get('packEditor.images.search.or')}}</span>
            <button type="button" class="btn btn-outline-secondary" data-click="chooseImage">{{>~l18n.get('packEditor.images.upload')}}</button>
        </div>
        
        {{if canDelete}}
            <div style="flex:1;" class="text-right">
                <button type="button" class="mb-3 mr-4 btn btn-outline-danger" data-click="removeImage" title="{{>~l18n.get('packEditor.images.remove')}}"><span class="far fa-trash-alt"></span></button>
            </div>
        {{/if}}
    </div>
    <div class="fl-form-select-image-gallery"></div>
</div>
`);

const SelectImageDialog_Image = $.templates(`
<div class="fl-form-select-image-gallery__image">
    <button type="button" class="btn" data-data="{{attr:data}}" data-click="selectGalleryImage">
        <img src="{{attr:src}}" alt="">
    </button>
</div>
`);

const SelectImageDialog_Empty = $.templates(`
<div class="fl-form-select-image-gallery--empty">
    {{>~l18n.get('packEditor.images.emptySearch')}}
</div>
`);

const SelectImageDialog_ListItemImage = $.templates(`
<div class="fl-form-cards__side-picture">
    <img src="{{attr:src}}" alt="">
</div>
`);

const SelectImageDialog_PackImage = $.templates(`
<span class="fl-va-helper"></span>
<img src="{{attr:src}}" alt="">
`);


class SelectImageDialog {
    constructor(opts) {
        const renderContext = {
            l18n: opts.l18n
        };

        const canDelete = !!opts.canDelete;
        const complete = opts.complete || noop;
        const remove = opts.remove || noop;

        Modaller.showLocal(SelectImageDialog_ModalBody.render({canDelete: canDelete}, renderContext), modaller => {
            const content = modaller.content;

            modaller.center();
            modaller.addDialogClass('modal-lg');
            modaller.addBodyClass('pb-0');

            content.find('button[data-click=closeDialog]').click(() => {
                modaller.close();
            });

            // remove previous file
            content.find('button[data-click=removeImage]').click(() => {
                remove();
                modaller.close();
            });

            // search remote file
            const searchInput = content.find('input[type=text]');
            const searchButton = content.find('button[data-click=searchImage]');
            searchInput.on('textchange', function () {
                searchButton.prop('disabled', this.value.trim().length === 0);
            });
            searchInput.on('keypress', function (e) {
                if (isEnterEvent(e) && !searchButton.prop('disabled')) {
                    searchButton.click();
                }
            });

            searchButton.click(function () {
                const button = new ProgressButton(this);
                button.progress = true;

                const params = {
                    method: 'flickr.photos.search',
                    api_key: '17d2fd46fcc0c2f65be945e5d05a01f5',
                    text: searchInput.val().trim(),
                    sort: 'relevance',
                    privacy_filter: 1,
                    safe_search: 1,
                    media: 'photos',
                    format: 'json',
                    nojsoncallback: 1,
                    per_page: 20
                };
                $.getJSON('https://api.flickr.com/services/rest/', params, res => {
                    const gallery = content.find('.fl-form-select-image-gallery')
                        .empty();

                    if (res && res.photos && res.photos.pages) {
                        const html = res.photos.photo
                            .map(el => {
                                return {
                                    data: `flickr:${el.farm}/${el.server}/${el.id}/${el.secret}`,
                                    src: `https://farm${el.farm}.staticflickr.com/${el.server}/${el.id}_${el.secret}_m.jpg`
                                }
                            })
                            .map(el => SelectImageDialog_Image.render(el))
                            .join('');
                        gallery.append(html);
                    } else {
                        gallery.append(SelectImageDialog_Empty.render({}, renderContext));
                    }

                    gallery.get(0).scrollLeft = 0;
                    button.progress = false;
                    modaller.handleUpdate();
                });
            });

            content.on('click', 'button[data-click=selectGalleryImage]', function () {
                const btn = $(this), data = btn.data('data'), src = btn.find('img').attr('src');
                complete(src, null, data);
                modaller.close();
            });

            // load local file
            const fileInput = content.find('input[type=file]');
            fileInput.change(function () {
                if (this.files && this.files[0]) {
                    const reader = new FileReader();
                    reader.onload = function (e) {
                        complete(e.target.result, fileInput);
                        modaller.close();
                    };
                    reader.readAsDataURL(this.files[0]);
                }
            });
            content.find('button[data-click=chooseImage]').click(() => {
                fileInput.click();
            });

            modaller.addShowListener(function () {
                searchInput.focus();
            });
        });
    }
}

class TextImport {
    constructor() {
        this.mode = '';
        this.ldLine = false;
        this.ldDoubleLine = false;
        this.ldJoinLowercase = false;
        this.ldCustom = false;
        this.ldCustomSymbol = '';
        this.tdDash = false;
        this.tdTab = false;
        this.tdCustom = false;
        this.tdCustomSymbol = '';

        this.llDoubleLine = false;
        this.llJoinLowercase = false;
    }

    _createLineByLineLineReader(pairReceiver) {
        const llDoubleLine = this.llDoubleLine;
        return (textContent) => {
            if (this.llJoinLowercase) {
                textContent = _joinLowerCaseStartingLinesOfText(textContent);
            }

            let key = '';
            let value = '';
            let acceptor = keyConsumer;
            let newLines = 0;

            function pushLine() {
                acceptor = keyConsumer;
                pairReceiver(key, value);
                key = '';
                value = '';
            }

            function valueConsumer(ch, newLine) {
                if (newLine && !llDoubleLine) {
                    pushLine();
                    return;
                }
                if (newLine && llDoubleLine && newLines === 2) {
                    pushLine();
                    return;
                }

                value += ch;
            }

            function keyConsumer(ch, newLine) {
                if (newLine && key.length === 0) {
                    return;
                }
                if (newLine) {
                    acceptor = valueConsumer;
                } else {
                    key += ch;
                }
            }

            for (let i = 0; i < textContent.length; ++i) {
                const ch = textContent[i];
                if (ch === '\r') {
                    continue;
                }
                if (ch === '\n') {
                    newLines += 1;
                } else {
                    newLines = 0;
                }
                acceptor(ch, ch === '\n');
            }

            pushLine();
        };
    }

    _createEveryLineLineReader(lineReceiver) {
        const eol = /\n$/;
        const eol2 = /\n\n$/;
        const custom = this.ldCustom ? _escapeRegex(this.ldCustomSymbol) : null;

        return (textContent) => {
            if (this.ldJoinLowercase) {
                textContent = _joinLowerCaseStartingLinesOfText(textContent);
            }

            let line = '';

            const lines = [];

            function pushLine(trimEndSymbols) {
                const candidate = trimEndSymbols > 0 ? line.slice(0, -trimEndSymbols) : line;
                if (candidate.length > 0) {
                    lines.push(candidate);
                }
                line = '';
            }

            for (let i = 0; i < textContent.length; ++i) {
                const ch = textContent[i];
                if (ch === '\r') {
                    continue;
                }

                line += ch;
                if (this.ldLine && eol.test(line)) {
                    pushLine(1);
                } else if (this.ldDoubleLine && eol2.test(line)) {
                    pushLine(2);
                } else if (custom !== null && custom.test(line)) {
                    pushLine(this.ldCustomSymbol.length);
                }
            }
            pushLine(0);

            lines.forEach(lineReceiver);
        };
    }

    _createEveryLinePairReader(pairReceiver) {
        const tab = this.tdTab ? /\t+/ : null;
        const dash = this.tdDash ? _dashRegex() : null;
        const custom = this.tdCustom ? _escapeRegex(this.tdCustomSymbol) : null;

        function pushPairMatch(line, match) {
            if (match === null) {
                return false;
            }

            const matchLength = match[0].length;
            const matchIndex = match.index;

            const key = line.substring(0, matchIndex).trim();
            const value = line.substring(matchIndex + matchLength).trim();

            if (key.length > 0 && value.length > 0) {
                pairReceiver(key, value);
                return true;
            }

            return false;
        }

        return (line) => {
            if (tab !== null && pushPairMatch(line, tab.exec(line))) {
                return;
            }
            if (dash !== null && pushPairMatch(line, dash.exec(line))) {
                return;
            }
            if (custom !== null) {
                pushPairMatch(line, custom.exec(line));
            }
        };
    }

    _createTextNormalizer() {
        const ops = [];
        // trim end space
        ops.push(s => s.replace(/[\n\s]+$/, ''));
        // trim head space
        ops.push(s => s.replace(/^[\n\s]+/, ''));
        // remove new lines
        ops.push(s => s.replace(/\n+/, ' '));
        // remove space before comma
        ops.push(s => s.replace(/\s+,/, ','));
        // final
        return s => {
            let out = s;
            for (let i = 0; out !== null && i < ops.length; ++i) {
                out = ops[i](out);
            }
            return out;
        };
    }

    parse(textContent, pairReceiver) {
        const n = this._createTextNormalizer();
        const localPairReceiver = (key, value) => {
            const cleanKey = n(key);
            const cleanValue = n(value);
            if (cleanKey !== null && cleanKey.length > 0 && cleanValue !== null && cleanValue.length > 0) {
                pairReceiver(cleanKey, cleanValue);
            }
        };

        let textReader;
        switch (this.mode) {
            case 'everyLine':
                const pairReader = this._createEveryLinePairReader(localPairReceiver);
                textReader = this._createEveryLineLineReader(pairReader);
                break;
            case 'lineByLine':
                textReader = this._createLineByLineLineReader(localPairReceiver);
                break;
        }

        textReader(textContent);
    }
}

const GUEST_MODAL = $.templates(`
    <p class="text-center">{{>~l18n.get(messageCode)}}</p>
    <p class="text-center"><span style="margin-right: 1em;">{{>~l18n.get(buttonCode)}}</span><a href="/login" class="btn btn-primary">{{>~l18n.get('packPage.dialogs.login')}}</a></p>
`);

class PageEdit {
    constructor(props) {
        if (!props.authenticated) {
            setTimeout(() => {
                this.showLoginDialog();
            }, 1500);
        }

        this.l18n = Texter.create(props.l18n);

        this.importText = new TextImport();
        this.importTextParsed = [];
        this.importTextPanel = $('#importTextPanel');
        this.importTextSubmit = this.importTextPanel.find('button[data-click-handler=applyTextImport]');
        this.importTextSubmit.click(this.applyTextImport.bind(this));

        this.form = $('#form');
        this.formMain = this.form.find('.fl-form-main');
        this.formMainFixed = this.form.find('.fl-form-main-fixed');
        this.formMainFixedEnabled = false;

        this._configureLanguages();

        const windowScrollCheck = () => {
            const position = this.formMain.get(0).getBoundingClientRect();
            this._toggleMainFix(position.bottom <= 0, position);
        };

        $(window).scroll(windowScrollCheck);
        windowScrollCheck();

        //>> initialize card list
        const initialCardList = props.cardList;
        const initialCardErrors = props.cardErrors || [];
        initialCardErrors.forEach(v => {
            initialCardList[v.index].faceError = v.face;
            initialCardList[v.index].backError = v.back;
        });

        this.listEditor = new ListEditor(this.l18n);
        this.listEditor.list.empty();
        this.listEditor.appendRowList(initialCardList);
        this.listEditor.onCardChange = (newCount) => {
            var noticeSplit = newCount > 20;
            this.form.find('*[data-condition=packSplitter]').toggle(noticeSplit);
            if (!noticeSplit) {
                this.form.find('input[name=split]').prop('checked', false);
            }
        };
        this.listEditor.countCards();
        //<< initialize card list

        $('#moreRows').click(() => {
            this.listEditor.appendEmpty();
            return false;
        });

        this.form.find('button[data-click=newCollection]').click(() => {
            new NewCollectionAction({
                l18n: this.l18n,
                onComplete: (dialog) => {
                    if (dialog.result !== null) {
                        const option = $('<option></option>');
                        option.attr('value', dialog.result.groupId);
                        option.text(dialog.result.groupName);
                        this.form.find('select[name=putToCollection]')
                            .append(option)
                            .val(dialog.result.groupId);
                    }
                }
            }).execute();
        });

        this.form.find('[data-click=selectPackThumb]').click(() => {
            new SelectImageDialog({
                l18n: this.l18n,
                canDelete: this._hasThumbImage(),
                remove: () => {
                    this._clearThumbImage();
                },
                complete: (imageSrc, imageInput, imageString) => {
                    this._setThumbImage(imageString, imageSrc, imageInput);
                }
            });
        });

        // scroll to first error
        const firstError = this.form.find('.is-invalid');
        if (firstError.length) {
            scrollIntoView(firstError.get(0));

            const jqWindow = $(window);
            jqWindow.scrollTop(jqWindow.scrollTop() - 100);
        }

        this.form.find('button[data-handler=submit]').prop('disabled', false);
    }

    _hasThumbImage() {
        const place = this.form.find('[data-bind=packThumb]');
        return place.children().length > 0;
    }

    _clearThumbImage() {
        const place = this.form.find('[data-bind=packThumb]');

        place.empty();
        place.parent().addClass('fl-form-main__thumb--empty');
    }

    /**
     * @param {String} imageString это локальный URI (local:-1_asdasd.png или подобное). Будет хранится в базе
     * @param {String} imageSrc это полноценный src для image
     * @param [imageInput] это input[type=file], откуда к нам попал файлик.
     * @private
     */
    _setThumbImage(imageString, imageSrc, imageInput) {
        this._clearThumbImage();

        const place = this.form.find('[data-bind=packThumb]');

        // result.fileInput
        place
            .empty()
            .append(SelectImageDialog_PackImage.render({src: imageSrc}));

        if (imageInput) {
            imageInput = $(imageInput);
            imageInput.attr('name', `thumbF`);
            place.append(imageInput.remove());

            imageString = 'local';
        }

        if (imageString) {
            place.append($(`<input type="hidden" name="thumb" value="${imageString}">`));
        }

        place.parent().removeClass('fl-form-main__thumb--empty');
    }

    _toggleMainFix(enabled, bounds) {
        if (this.formMainFixedEnabled === enabled) {
            return;
        }

        if (enabled) {
            this.formMainFixed
                .css({
                    left: bounds.left,
                    width: bounds.width
                })
                .show();
        } else {
            this.formMainFixed.hide();
        }

        this.formMainFixedEnabled = enabled;
    }

    _configureLanguages() {
        const locale = /(.+)-(.+)/.exec(navigator['language'] || navigator['userLanguage']);
        const userLanguage = locale && locale[1] ? locale[1] : null;

        function initSelect(select) {
            select.find('option[value=en]').remove().prependTo(select);
            if (userLanguage) {
                select.find(`option[value=${userLanguage}]`).remove().prependTo(select);
            }
            select
                .removeClass('custom-select')
                .selectpicker("refresh");
        }

        initSelect(this.form.find('select[name=faceLocale]'));
        initSelect(this.form.find('select[name=backLocale]'));
    }

    applyTextImport() {
        if (this.importTextParsed.length > 0) {
            this.listEditor.removeEmptyTail();

            this.importTextParsed.forEach(item => {
                this.listEditor.appendRow({
                    face: item[0],
                    back: item[1]
                });
            });

            this.listEditor.appendEmpty();
            this.listEditor.countCards();
        }
        this.hideTextImport();
    }

    hideTextImport() {
        this.importTextPanel.hide();
        this.importTextPanel.find('input[data-import-option]').off('change');
        this.importTextPanel.find('textarea').off('textchange');
        $('#importTextPreview').hide();

        this.form.show();
        return false;
    }

    showTextImport() {
        const importTextPanel = this.importTextPanel;
        importTextPanel.show();

        $('#importTextContent').val('')
        $('#importTextPreview')
            .find('ul').empty().end()
            .show();

        let previewImportRequest = 1;
        const previewImport = () => {
            const importText = this.importText;

            this.importTextSubmit
                .addClass('btn-in-progress')
                .prop('disabled', true);

            let previewImportRequestCurrent = ++previewImportRequest;
            setTimeout(() => {
                if (previewImportRequestCurrent !== previewImportRequest) {
                    return;
                }

                importTextPanel.find('input[data-import-option]').each(function () {
                    const input = $(this), option = input.data('import-option');
                    switch (this.type) {
                        case 'checkbox':
                            importText[option] = input.is(':checked');
                            break;
                        case 'radio':
                            if (input.is(':checked')) {
                                importText[option] = input.val();
                            }
                            break;
                        default:
                            importText[option] = input.val();
                            break;
                    }
                });

                let text = $('#importTextContent').val();
                this.importTextParsed = [];

                importText.parse(text, (k, v) => {
                    this.importTextParsed.push([k, v]);
                });

                let html = '';
                this.importTextParsed.forEach(item => {
                    html += `<li class="fl-form-cards__card panel mt-2">
<div class="fl-form-cards__faces row">
            <div class="col-md-6 fl-form-cards__face-side">
                    <div class="fl-form-cards__side-input">
                        <div>${escapeHtml(item[0])}</div>
                    </div>
            </div>
            <div class="col-md-6 fl-form-cards__back-side">
                    <div class="fl-form-cards__side-input">
                        <div>${escapeHtml(item[1])}</div>
                    </div>
            </div>
</div>
</li>`;
                });
                if (this.importTextParsed.length === 0 && text.length > 0) {
                    html = `<li class="text-center alert alert-info mt-3 mb-0">${this.l18n.get('packEditor.importer.preview.empty')}</li>`;
                }

                this.importTextSubmit
                    .removeClass('btn-in-progress')
                    .prop('disabled', this.importTextParsed.length <= 0);

                $('#importTextPreview')
                    .find('ul').html(html).end()
                    .show();

            }, 200);
        };

        importTextPanel.find('input[data-import-option]').on('change textchange', previewImport);
        importTextPanel.find('input[type=radio][data-import-option=mode]').change(function () {
            importTextPanel
                .removeClass('ldMode-everyLine ldMode-lineByLine')
                .addClass('ldMode-' + $(this).val());
        })

        importTextPanel.find('textarea').on('textchange', previewImport);
        previewImport();

        this.form.hide();
        return false;
    }

    showAnkiImport() {
        const self = this;
        const template = $.templates(`
<div data-section="browse" style="display: none;">
    <p class="text-center">{{>~l18n.get('packEditor.anki.dialog.message')}}</p>
    <p class="text-center"><button class="btn btn-primary" data-handler="load">{{>~l18n.get('packEditor.anki.dialog.button')}}</button></p>
    <p class="text-left mb-0" style="font-size: .6rem; opacity: .7">{{>~l18n.get('packEditor.anki.dialog.notice1')}}</p>
    <p class="text-left mb-0" style="font-size: .6rem; opacity: .7">{{>~l18n.get('packEditor.anki.dialog.notice2')}}</p>
    <input style="display: none;" type="file" name="ankiFile"/>
</div>
<div data-section="progress" style="display: none;">
    <p class="text-center" data-bind="message"></p>
    <div style="width:100%;height: .3rem;border-radius: .1rem;background: #e6e6e6;">
        <div style="height:100%;background: #add1ec;border-radius: .1rem; width: 0;" data-bind="percent"></div>
    </div>
</div>
<div data-section="error" style="display: none;">
    <p class="alert alert-info text-center mb-0" data-bind="error">{{>~l18n.get('packEditor.anki.progress.error')}}</p>
</div>
<div data-section="success" style="display: none;">
    <p class="alert alert-info text-center mb-0" data-bind="error">{{:~l18n.get('packEditor.anki.progress.success')}}</p>
</div>
`);
        Modaller.showLocal(template.render({}, this), modaller => {
            const dialog = modaller.content;

            const showSection = function (name) {
                dialog.find('div[data-section]').hide();
                dialog.find(`div[data-section=${name}]`).show();
            };
            showSection('browse');

            let alive = true;
            let upload = null;

            modaller.setTitle(this.l18n.get('packEditor.anki.dialog.title'));
            modaller.addHideListener(() => {
                alive = false;
                if (upload != null) {
                    upload.cancel();
                    upload = null;
                }
            });


            const fileInput = dialog.find('input[name=ankiFile]');

            dialog.find('button[data-handler=load]').click(() => {
                fileInput.click();
            });

            const showCloseButton = () => {
                modaller.addFooterButton(this.l18n.get('button.close'), 'btn btn-light', () => {
                    modaller.close()
                });
            };

            const progressText = (messageCode) => {
                dialog.find('p[data-bind=message]').text(this.l18n.get(messageCode));
                dialog.find('div[data-bind=percent]').css('width', '100%');
            };

            const progressLoader = (loaded, total) => {
                const percent = total > 0 ? (100 * loaded / total) : 50;
                dialog.find('div[data-bind=percent]').css('width', percent + '%');

                if (total > 0 && loaded === total) {
                    progressText('packEditor.anki.progress.parsing');
                }
            };

            const finishSuccess = () => {
                showSection('success');
                showCloseButton();
            };

            const finishError = () => {
                showSection('error');
                showCloseButton();
            };

            fileInput.on("change", function () {
                const file = $(this)[0].files[0];

                showSection('progress');
                progressText('packEditor.anki.progress.sending');

                upload = new FileUpload(file);
                upload.progressListener = progressLoader;
                upload.doUpload(`${Flashcards.root}/new-pack/import-anki`).then(
                    res => {
                        progressText('packEditor.anki.progress.forming');
                        if (!alive) return;

                        if (res.status !== 'ok') {
                            finishError();
                            return;
                        }

                        self.listEditor.clear();
                        res.data.cards.forEach(v => {
                            self.listEditor.appendRow(v);
                        });
                        self.listEditor.appendEmpty();

                        function updateTextValue(jqInput, value) {
                            const current = jqInput.val();
                            if (current.length || value === undefined || value == null || value === "") {
                                return;
                            }
                            jqInput.val(value);
                        }

                        function updateSelectValue(jqSelect, value) {
                            const current = jqSelect.val();
                            const next = jqSelect.find(`option[value=${value}]`);
                            if (current || next.length === 0) {
                                return;
                            }
                            jqSelect.val(value).selectpicker('refresh');
                        }

                        updateTextValue(self.form.find('input[name=title]'), res.data.title);
                        updateTextValue(self.form.find('textarea[name=description]'), res.data.description);
                        updateSelectValue(self.form.find('select[name=faceLocale]'), res.data.faceLocale);
                        updateSelectValue(self.form.find('select[name=backLocale]'), res.data.backLocale);

                        if (!self._hasThumbImage() && res.data.thumb && res.data.thumbSrc) {
                            self._setThumbImage(res.data.thumb, res.data.thumbSrc);
                        }

                        finishSuccess();
                    },
                    () => finishError);
            })
        });
    }

    checkSubmit() {
        const cardCount = this.listEditor.countCards();

        const enoughCards = cardCount >= 2;
        const enoughCardsAlert = $('#cardListError');

        // show "not enough cards" alert
        enoughCardsAlert.toggle(!enoughCards);
        this.listEditor.list.toggleClass('fl-form-cards--danger', !enoughCards);

        // scroll to error alert
        if (!enoughCards) {
            scrollIntoView(this.form);
        }

        return enoughCards;
    }

    submit() {
        if (!this.checkSubmit()) {
            return false;
        }
        this.form.find('button[data-handler=submit]').prop('disabled', true);
        this.form.submit();
        return true;
    }

    showLoginDialog() {
        const html = GUEST_MODAL.render({
            messageCode: 'packPage.dialogs.forbidden.createNew.text',
            buttonCode: '',
        }, this);
        Modaller.showLocal(html, modaller => {
            modaller.setTitle(this.l18n.get('packPage.dialogs.forbidden.createNew.title'));
            modaller.disableHide();
        });
    }
}

global.PageEdit = PageEdit;